module.exports = __webpack_public_path__ + "media/images/e-bilet/directions/ivano-frankivsk-lviv-c5dbad9363c303817b10e9bf9766ac69.png";